module.exports = __webpack_public_path__ + "media/icons/slider-arrow-2db2f9cd.svg";